// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"styles_containerMain__2HPuq","popupBackground":"styles_popupBackground__2ZH73"};